import SharedAsset from '@zenbusiness/common-components/SharedAsset';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const ImageAsset = styled(SharedAsset)(() => ({
  objectFit: 'cover',
  borderRadius: '1.5rem',
  width: '100%'
}));

export const ImageContainer = styled(Box)({
  width: '100%',
  marginBottom: '1rem'
});
